"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const thread_1 = require("../../../app/dist/thread");
exports.toolDef = {
    name: 'loom_move_thread',
    description: "Move a thread folder to another weave (loom/{fromWeaveId}/{threadId} → loom/{toWeaveId}/{threadId}). The thread's th_ ULID travels with it, so depends_on edges survive; docs keep their ULIDs. Refuses if the destination weave is missing or already has a thread with that id. Use this tool — do not move thread folders directly.",
    inputSchema: {
        type: 'object',
        properties: {
            fromWeaveId: { type: 'string', description: 'Source weave id.' },
            threadId: { type: 'string', description: 'Thread id (folder name) to move.' },
            toWeaveId: { type: 'string', description: 'Destination weave id (must already exist).' },
        },
        required: ['fromWeaveId', 'threadId', 'toWeaveId'],
    },
};
async function handle(root, args) {
    const result = await (0, thread_1.moveThread)({ fromWeaveId: args['fromWeaveId'], threadId: args['threadId'], toWeaveId: args['toWeaveId'] }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
